import { apiFetcher } from "./apiFetcher";
import { versioningService } from "./versioning.service";
import _ from 'lodash'

const categoriesPerPage = 100

/** Wix category tree reference — Wix Stores always uses this. */
const STORES_TREE_REFERENCE = { appNamespace: '@wix/stores', treeKey: null };

export const categoriesService = {
  getCategories,
  getAllCategories
};

function getCategories(storeId, page, accessToken) {
  const url = `stores/v1/collections/query`

  const body = {
    query: {
      paging: {
        offset: (page-1) * categoriesPerPage
      }
    }
  }

  return apiFetcher(storeId, accessToken, url, { method: "POST", body: JSON.stringify(body) });
}

// Detect the catalog version and page through categories accordingly. V1 returns
// `collections` (offset paging); V3 returns `categories` (cursor paging, requires a
// treeReference). Both are normalized to a flat array of `{ id, name, visible }`.
function getAllCategories(storeId, page = 1, categoriesArray = [], accessToken) {
  return versioningService.getCatalogVersion(storeId, accessToken).then((version) =>
    version === 'V3'
      ? getAllCategoriesV3(storeId, accessToken)
      : getAllCategoriesV1(storeId, page, categoriesArray, accessToken),
  );
}

function getAllCategoriesV1(storeId, page = 1, categoriesArray = [], accessToken) {
  return getCategories(storeId, page, accessToken)
    .then(response => {
      categoriesArray = categoriesArray.concat(response?.collections);
      page += 1;
      if(!_.isEmpty(response?.collections)){
        return getAllCategoriesV1(storeId, page, categoriesArray, accessToken);
      }else{
        return categoriesArray
      }
    })
    .catch(() => {
      return categoriesArray;
    })
}

function getAllCategoriesV3(storeId, accessToken, cursor = null, categoriesArray = []) {
  const body = {
    query: { cursorPaging: { limit: categoriesPerPage, ...(cursor ? { cursor } : {}) } },
    treeReference: STORES_TREE_REFERENCE,
    returnNonVisibleCategories: false,
  };

  // The V3 Categories API lives on its own host/path (NOT under stores/v3).
  return apiFetcher(
    storeId,
    accessToken,
    `categories/v1/categories/query`,
    { method: "POST", body: JSON.stringify(body) },
  )
    .then((response) => {
      const batch = (response?.categories || []).filter((c) => c.visible !== false);
      categoriesArray = categoriesArray.concat(batch);
      const next = _.get(response, 'pagingMetadata.cursors.next', null);
      if (_.get(response, 'pagingMetadata.hasNext') && next) {
        return getAllCategoriesV3(storeId, accessToken, next, categoriesArray);
      }
      return categoriesArray;
    })
    .catch(() => categoriesArray);
}
